var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'isLoading': _vm.isLoading }},[(!_vm.isLoading)?_c('v-autocomplete',_vm._b({staticClass:"base-select reduce-div",attrs:{"hide-details":"","clearable":_vm.clear,"label":_vm.label,"items":_vm.items,"value":_vm.value},on:{"input":_vm.sendValue}},'v-autocomplete',_vm.$attrs,false)):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffef2922","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/inputs/base-select.vue
// module id = 815
// module chunks = 11 13 14 15 16 18 20 22 31 32 36 50